export default [
  {
    path: '/company',
    component: () => import('./components/company-filter-form.vue')
  },
  {
    path: '/company/public',
    component: () => import('./components/company-filter-form.vue')
  },
  {
    path: '/company/shared',
    component: () => import('./components/company-filter-form.vue')
  },
  {
    path: '/company/verified',
    component: () => import('./components/company-filter-form.vue')
  },
  {
    path: '/public/company',
    component: () => import('./components/company-filter-form.vue')
  }
];
